<template>
  <div
      v-if="pagination"
      id="pagination"
  >
    <a
        v-if="pagination.current_page !== 1"
        class="prev btn-pagination"
        v-on:click="previous"
    >
      Vorige
    </a>
    <a
        v-if="pagination.current_page !== 1"
        class="firstpage btn-pagination"
        v-on:click="firstPage"
    >
      1
    </a>
    <div v-if="this.paginationShortcutsFloor !== null && this.paginationShortcutsFloor.length > 0">
      <a v-for="paginationFloorShortcut in this.paginationShortcutsFloor.slice().reverse()"
         v-bind:key="paginationFloorShortcut"
         class="btn-pagination floorShortcuts"
         v-on:click="openPage(paginationFloorShortcut)"
      >
        {{ paginationFloorShortcut }}
      </a>
    </div>

    <div class="currentpage">
      {{ pagination.current_page }}
    </div>

    <div v-if="this.paginationShortcutsCeil !== null">
      <a v-for="paginationCeilShortcut in this.paginationShortcutsCeil" v-bind:key="paginationCeilShortcut"
         class="btn-pagination ceilShortcuts"
         v-on:click="openPage(paginationCeilShortcut)"
      >
        {{ paginationCeilShortcut }}
      </a>
    </div>
    <a
        v-if="pagination.current_page !== pagination.last_page"
        class="lastpage btn-pagination"
        v-on:click="lastPage"
    >
      {{ pagination.last_page }}
    </a>
    <a
        v-if="pagination.current_page !== pagination.last_page"
        class="next btn-pagination"
        v-on:click="next"
    >
      Volgende
    </a>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    pagination: null,
  },
  data() {
    return {
      page: '',
      paginationShortcutsCeil: null,
      paginationShortcutsFloor: null
    }
  },
  methods: {
    firstPage() {
      this.clearPaginationShortcuts();
      let newPageNumber = 1;
      localStorage.setItem(this.getPage(), newPageNumber + '');
      this.loadContent(1);
    },
    lastPage() {
      this.clearPaginationShortcuts();
      localStorage.setItem(this.getPage(), this.pagination.last_page + '');
      this.loadContent(this.pagination.last_page);
    },
    next() {
      this.clearPaginationShortcuts();
      let newPageNumber = this.pagination.current_page += 1;
      localStorage.setItem(this.getPage(), newPageNumber + '');
      this.loadContent(newPageNumber);
    },
    previous() {
      this.clearPaginationShortcuts();
      let newPageNumber = this.pagination.current_page -= 1;
      localStorage.setItem(this.getPage(), newPageNumber + '');
      this.loadContent(newPageNumber);
    },
    loadContent(pageNumber) {
      if (this.page === 'reviews') {
        this.$router.push("/reviews/page/" + pageNumber);
      } else if (this.page === 'companies') {
        this.$router.push("/companies/page/" + pageNumber);
      } else if (this.page === 'favorites') {
        this.$router.push("/favorites/page/" + pageNumber);
      } else if (this.page === 'exact') {
        this.$router.push("/exact/page/" + pageNumber);
      }
    },
    getPage() {
      if (this.page === 'reviews') {
        return 'postsPage';
      } else if (this.page === 'companies') {
        return 'organisationsPage';
      } else if(this.page === 'favorites') {
        return 'favoritesPage';
      }  else if(this.page === 'exact') {
        return 'exactPage';
      }
    },
    openPage(pageNumber) {
      this.clearPaginationShortcuts();
      localStorage.setItem(this.getPage(), pageNumber + '');
      this.loadContent(pageNumber);
    },
    clearPaginationShortcuts() {
      this.paginationShortcutsFloor = null;
      this.paginationShortcutsCeil = null;
    }
  },
  beforeUpdate() {
    let shortcutsCeil = [];
    let shortcutsFloor = []

    let closestShortcutCeil = Math.ceil(this.pagination.current_page / 10) * 10;
    let closestShortcutFloor = Math.floor(this.pagination.current_page / 10) * 10;

    if (closestShortcutCeil !== this.pagination.current_page && closestShortcutCeil < this.pagination.last_page) {
      shortcutsCeil.push(closestShortcutCeil);
    }

    if (closestShortcutFloor !== this.pagination.current_page && closestShortcutFloor !== 0) {
      shortcutsFloor.push(closestShortcutFloor);
    }

    for (let i = 1; i < 5; i++) {
      let nextCeilValue = closestShortcutCeil + (i * 10);

      if (nextCeilValue !== this.pagination.current_page && nextCeilValue < this.pagination.last_page) {
        shortcutsCeil.push(nextCeilValue);
      }

      let nextFloorValue = closestShortcutFloor - (i * 10);
      if (nextFloorValue > 1 && nextFloorValue !== this.pagination.current_page) {
        shortcutsFloor.push(nextFloorValue);
      }
    }

    this.paginationShortcutsCeil = shortcutsCeil;
    this.paginationShortcutsFloor = shortcutsFloor;

    if (this.$route.fullPath.includes('reviews')) {
      this.page = 'reviews'
    } else if (this.$route.fullPath.includes('companies')) {
      this.page = 'companies'
    } else if(this.$route.fullPath.includes('favorites'))  {
      this.page = 'favorites'
    } else if(this.$route.fullPath.includes('exact'))  {
      this.page = 'exact'
    }
  }
};
</script>
